import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.patient': {
         choose: 'Wybierz',
         fetchingNFZDepartmentsList: 'Pobieranie listy oddziałów NFZ',
         missingNfzDepartment: 'Brakujący oddział NFZ pacjenta',
         nfzDepartmentsFetchError: 'Nie udało się pobrać listy oddziałów NFZ. Spróbuj ponownie',
         patientNFZDepartmentSuccessfullyUpdated: 'Oddział NFZ pacjenta został pomyślnie zaktualizowany.',
         patientNfzDepartment: 'Oddział NFZ pacjenta',
         save: 'Zapisz',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.patient');
